import BaseClass from "../BaseClass";

export default class CheckboxCollapse extends BaseClass {
    constructor(element) {
        super(element);

        this.checkboxSelector = this.$element.data('checkbox');
        this.collapsibleSelector = this.$element.data('collapsible');

        this.initElements();
        this.initCallbacks();
        this.initListeners();

        this.initCollapse();
        this.onCheckboxChange();
    }

    initElements() {
        this.$checkboxes = this.$element.find(this.checkboxSelector);
        this.$collapsible = this.$element.find(this.collapsibleSelector);
    }

    initCallbacks() {
        const self = this;

        this.onCheckboxChangeCb = function () {
            self.onCheckboxChange();
        }
    }

    initListeners() {
        this.$checkboxes.on('change', this.onCheckboxChangeCb);
    }

    initCollapse() {
        let options = this.$element.data('options');

        if (options == undefined) {
            options = {
                toggle: false
            };
        }

        this.$collapsible.collapse(options);
    }

    onCheckboxChange() {
        let checked = this.$checkboxes.is(':checked');

        let logic = this.$element.data('logic');

        if (logic != undefined && logic == 'reverse') {
            checked = !this.$checkboxes.is(':checked');
        }

        if (checked) {
            this.$collapsible.collapse('show');
        } else {
            this.$collapsible.collapse('hide');
        }
    }

    teardown() {
        this.$collapsible.collapse('dispose');

        this.teardownListeners();
        this.teardownCallbacks();
        this.teardownElements();
    }

    teardownListeners() {
        this.$checkboxes.off('change', this.onCheckboxChangeCb);
    }

    teardownCallbacks() {
        delete this.onCheckboxChangeCb;
    }

    teardownElements() {
        delete this.$checkboxes;
        delete this.$collapsible;
    }
}